import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { useNavigate, useParams } from 'react-router-dom';
import { useEventCallback } from '@mui/material';
import { DetailAmountCrubs } from 'front-office/constants/amount-crubs';
import FormAmount, { AmountForm } from 'front-office/components/amount/form';
import { __CERTIFICATION_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { ResponseAmount } from 'shell/models/response-amount';
import { HttpResponse } from 'shell/models/http-response';
import { transformerAmount } from 'front-office/utils/transformer-amount';

const DetailAmount = (): React.ReactElement => {
  const navigate = useNavigate();

  const params = useParams();

  const [importo] = useHttpFetch<HttpResponse<ResponseAmount>, AmountForm>(
    `${__CERTIFICATION_API_URL__}/certificazione/importo-pagamento/${params.codice}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformerAmount,
    }
  );

  const onCancel = useEventCallback(() => {
    navigate('/sportello/ricerca-importo');
  });

  return (
    <Fragment>
      <Breadcrumbs items={DetailAmountCrubs} />
      {importo.data ? (
        <FormAmount
          title="Dettaglio Importo Pagamento"
          onCancel={onCancel}
          initialValues={importo.data as AmountForm}
          disabled
        />
      ) : undefined}
    </Fragment>
  );
};

DetailAmount.displayName = 'Detail Amount component';

export default DetailAmount;
